/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Button, Col, Divider, Form, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox';

const ModalFilterItems = ({
  type,
  openFilterModal,
  setOpenFilterModal,
  setFilterItems,
  filterItems,
}) => {
  const { t } = useTranslation('');

  const initValue = {
    happiness: ['ALL'],
    purpose: ['ALL'],
    necessity: ['ALL'],
    probability: ['ALL'],
  };

  const [allValues, setAllValues] = useState(initValue);

  const scheema = {
    purpose: [100, 50, 0],
    happiness: [100, 50, 0],
    necessity: [100, 50, 0],
    probability: [100, 75, 50, 25, 0],
  };

  const handleValuesChange = (category, value, checked) => {
    let record = allValues?.[category] ?? [];
    if (checked) {
      if (value !== 'ALL' && record?.includes('ALL')) {
        record = record.filter((v) => v !== 'ALL');
      }
      if (value === 'ALL') {
        setAllValues({ ...allValues, [category]: ['ALL'] });
        return;
      }
      const newRecord = [...record, value];
      if (scheema[category].length === newRecord.length) {
        setAllValues({ ...allValues, [category]: ['ALL'] });
      } else {
        setAllValues({ ...allValues, [category]: newRecord });
      }
    } else if (value !== 'ALL') {
      setAllValues({
        ...allValues,
        [category]: record.filter((v) => v !== value),
      });
    }
  };

  const handleRestFilter = () => {
    setAllValues(initValue);
  };

  const handleClose = () => {
    setOpenFilterModal(false);
  };

  const onSubmit = () => {
    setFilterItems(allValues);
    setOpenFilterModal(false);
  };

  return (
    <Modal
      width={700}
      className="filter-modal"
      centered
      open={openFilterModal}
      onCancel={handleClose}
      footer={false}
      zIndex={1500}
    >
      <h1 className="modal-header-title">{t('FILTER')}</h1>
      <div className="">
        {type === 'expenses' ? (
          <div>
            <h2 className="filter-date-title">{t('HAPPINESS')}</h2>
            <Row
              style={{ width: '100%', margin: '16px 0 8px', padding: '0 16px' }}
              justify={'space-between'}
            >
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['happiness']?.includes('ALL')}
                  onChange={(e) =>
                    handleValuesChange('happiness', 'ALL', e.target.checked)
                  }
                >
                  {t('ALL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['happiness']?.includes(100)}
                  onChange={(e) =>
                    handleValuesChange('happiness', 100, e.target.checked)
                  }
                >
                  {t('JOYFUL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['happiness']?.includes(50)}
                  onChange={(e) =>
                    handleValuesChange('happiness', 50, e.target.checked)
                  }
                >
                  {t('CONTENT')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['happiness']?.includes(0)}
                  onChange={(e) =>
                    handleValuesChange('happiness', 0, e.target.checked)
                  }
                >
                  {t('NEUTRAL')}
                </CustomCheckbox>
              </Col>
            </Row>
            <Divider className="filter-divider" />
            <h2 className="filter-date-title">{t('PURPOSE')}</h2>
            <Row
              style={{ width: '100%', margin: '16px 0 8px', padding: '0 16px' }}
              justify={'space-between'}
            >
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['purpose']?.includes('ALL')}
                  onChange={(e) =>
                    handleValuesChange('purpose', 'ALL', e.target.checked)
                  }
                >
                  {t('ALL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['purpose']?.includes(100)}
                  onChange={(e) =>
                    handleValuesChange('purpose', 100, e.target.checked)
                  }
                >
                  {t('HIGHEST')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['purpose']?.includes(50)}
                  onChange={(e) =>
                    handleValuesChange('purpose', 50, e.target.checked)
                  }
                >
                  {t('MODERATE')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['purpose']?.includes(0)}
                  onChange={(e) =>
                    handleValuesChange('purpose', 0, e.target.checked)
                  }
                >
                  {t('NOT_AT_ALL')}
                </CustomCheckbox>
              </Col>
            </Row>
            <Divider className="filter-divider" />
            <h2 className="filter-date-title">{t('NECESSITY')}</h2>
            <Row
              style={{ width: '100%', margin: '16px 0 8px', padding: '0 16px' }}
              justify={'space-between'}
            >
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['necessity']?.includes('ALL')}
                  onChange={(e) =>
                    handleValuesChange('necessity', 'ALL', e.target.checked)
                  }
                >
                  {t('ALL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['necessity']?.includes(100)}
                  onChange={(e) =>
                    handleValuesChange('necessity', 100, e.target.checked)
                  }
                >
                  {t('ESSENTIAL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['necessity']?.includes(50)}
                  onChange={(e) =>
                    handleValuesChange('necessity', 50, e.target.checked)
                  }
                >
                  {t('USEFUL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['necessity']?.includes(0)}
                  onChange={(e) =>
                    handleValuesChange('necessity', 0, e.target.checked)
                  }
                >
                  {t('NOT_AT_ALL')}
                </CustomCheckbox>
              </Col>
            </Row>
            <Divider className="filter-divider" />
          </div>
        ) : (
          <div>
            <h2 className="filter-date-title">{t('PROBABILITY')}</h2>
            <Row
              style={{ width: '100%', margin: '16px 0 8px', padding: '0 16px' }}
              justify={'space-between'}
            >
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['probability']?.includes('ALL')}
                  onChange={(e) =>
                    handleValuesChange('probability', 'ALL', e.target.checked)
                  }
                >
                  {t('ALL')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['probability']?.includes(100)}
                  onChange={(e) =>
                    handleValuesChange('probability', 100, e.target.checked)
                  }
                >
                  {t('ITS_HAPPENING')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['probability']?.includes(75)}
                  onChange={(e) =>
                    handleValuesChange('probability', 75, e.target.checked)
                  }
                >
                  {t('HIGHLY_LIKELY')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['probability']?.includes(50)}
                  onChange={(e) =>
                    handleValuesChange('probability', 50, e.target.checked)
                  }
                >
                  {t('CONFINDENT')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['probability']?.includes(25)}
                  onChange={(e) =>
                    handleValuesChange('probability', 25, e.target.checked)
                  }
                >
                  {t('ITS_POSSIBLE')}
                </CustomCheckbox>
              </Col>
              <Col className="">
                <CustomCheckbox
                  checked={allValues?.['probability']?.includes(0)}
                  onChange={(e) =>
                    handleValuesChange('probability', 0, e.target.checked)
                  }
                >
                  {t('NOT_AT_ALL')}
                </CustomCheckbox>
              </Col>
            </Row>
            <Divider className="filter-divider" />
          </div>
        )}
        <Row className="modal-newportfolio-button-wrapper">
          <Button
            type="text"
            className="modal-action-btn cancel-btn"
            onClick={handleRestFilter}
          >
            {t('RESET')}
          </Button>
          <Button
            type="default"
            className="modal-action-btn save-btn"
            onClick={onSubmit}
          >
            {t('APPLY')}
          </Button>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalFilterItems;

ModalFilterItems.propTypes = {
  type: PropTypes.string,
  openFilterModal: PropTypes.bool,
  setOpenFilterModal: PropTypes.func,
  setFilterItems: PropTypes.func,
  filterItems: PropTypes.object,
};
